import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/pinia/auth'
import { useBasketStore } from '@/pinia/basket'
import { useStyleStore } from '@/pinia/style'
import { useCustomerStore } from '@/pinia/customer'
import { useTouchStore } from '@/pinia/touch'
import { useBrandedStore } from '@/pinia/branded'

export function useTabHandler() {
  const router = useRouter()
  const authStore = useAuthStore()
  const basketStore = useBasketStore()
  const brandedStore = useBrandedStore()
  const styleStore = useStyleStore()
  const customerStore = useCustomerStore()
  const touchStore = useTouchStore()

  function hydrate() {
    authStore.$hydrate()
    basketStore.$hydrate()
    brandedStore.$hydrate()
    styleStore.$hydrate()
    customerStore.$hydrate()
    touchStore.$hydrate()
  }

  function handleAuthChangesAcrossTabs(event) {
    if (authStore.installation === 'branded') return
    if (event.key === 'portal_auth' || event.key === 'business_auth') {
      const authhNew = JSON.parse(event.newValue)
      const authhOld = JSON.parse(event.oldValue)
      if (!authhNew?.loggedIn && authhOld?.loggedIn) {
        const url = authStore.login_url
        hydrate()
        router.replace({ path: url, query: { redirect: router.currentRoute.value.path } })
      } else if (authhNew?.loggedIn && !authhOld?.loggedIn) {
        hydrate()
      }
    }
  }

  onMounted(() => {
    window.addEventListener('storage', handleAuthChangesAcrossTabs)
  })
  onUnmounted(() => {
    window.removeEventListener('storage', handleAuthChangesAcrossTabs)
  })
}
